export default {
  main: {
    margin: '0 auto',
    maxWidth: '60em',
  },
}
